






















import Vue from 'vue'
import Navigation from './navigation.vue'

export default Vue.extend({
  components: {
    Navigation,
  },
})
